import { useState } from 'react'
import Account from './Account'
import Wechat from './Wechat'
import styles from './style.module.less'
import logo from '@/assets/images/logo.png'

const types = [
  { label: '扫码登录', value: 'scan' },
  { label: '账号密码登录', value: 'account' },
]

const Login = () => {
  const [type, setType] = useState('scan')

  return (
    <div className='h-full flex flex-column'>
      <div className={styles.wrap}>
        <img src={logo} alt="" className={styles.logo} />
        <div className={styles.box}>
          <div className={styles.container}>
            <div className='font-38 font-700 text-center mtb-30'>国检上海</div>
            <div className={`flex text-center font-20 ${styles.tab}`}>
              {
                types.map(t => (
                  <div key={t.value} onClick={() => setType(t.value)} className={`flex-1 mlr-20 ${styles['tab-item']} ${type === t.value ? styles.active : ''}`}>{t.label}</div>
                ))
              }
            </div>
            {
              type === 'account' ? <Account /> : <Wechat />
            }
          </div>
        </div>
      </div>
      <div className={styles.footer}>版权所有 国检测试控股集团上海有限公司 沪ICP备16050287号-2</div>
    </div>
  )
}

export default Login
